import "./Navbar.scss";
// REACT; REDUX; ROUTER
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

// COMPONENTS & FUNCTIONS
import NavbarMenu from "./Navbar-menu";
import * as FaIcons from "react-icons/fa";

// NPM INSTALLS

/*
NAVBAR COMPONENT INFORMATION
  MORE TO COME
*/

function Navbar() {
  // ::::: STATES :::::
  const [isMobile, setIsMobile] = useState(false);

  // ::::: USEHOOKS ::::::
  // const location = useLocation().pathname.split("/");

  useEffect(() => {
    window.screen.width <= 600 ? setIsMobile(true) : setIsMobile(false);
  }, [window.screen.width]);

  // :::::: FUNCTIONS ::::::
  // function detectWindowSize() {
  //   window.innerWidth <= 600 ? setIsMobile(true) : setIsMobile(false);
  // }
  // window.onresize = detectWindowSize;

  // const handleDarkLight = () => {
  //   document.body.classList.toggle("dark-mode");
  // };

  // :::::: JSX ::::::
  return (
    <nav className="navbar">
      <div className="navbar__container" id="navbar-container">
        {/* <button onClick={handleDarkLight}>DARK OR LIGHT</button> */}
        <div className="navbar__logo">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "navbar__link navbar__link--active" : "navbar__link"
            }
            id="navbar-home-button"
          >
            {isMobile ? <FaIcons.FaHome /> : "Home"}
          </NavLink>
        </div>
        <NavbarMenu />
      </div>
    </nav>
  );
}

export default Navbar;
